import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { INoteButton } from "../../app/models/toolbar";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  button: INoteButton;
}

export const ContentNoteButton: React.FC<IParams> = ({ button }) => {
  const rootStore = useContext(RootStoreContext);
  const { openContentNoteModal } = rootStore.playerStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  return (
    <>
      <Button
        id="btnContentNote"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          button.hasExistingNote
            ? `${theme!.toolbarActiveIconColor}`
            : `${theme!.toolbarIconColor}`
        )}
        color=""
        onClick={openContentNoteModal}
        style={{ position: "relative" }}
      >
        <i
          className={classNames(
            "far fa-sticky-note iconToolbarButton"
            // button.hasExistingNote ? "text-red" : ""
          )}
        ></i>
        <h6 className="textToolbarButton mb-0">
          {t("toolbar_notes_content_button")}
        </h6>
      </Button>
    </>
  );
};

export default observer(ContentNoteButton);
